import NodeEvents from 'events';
import * as Inovx from '@shared';
import RoleConstants from '../constants/RoleConstants';

declare var InovxLoader: any;

var EventEmitter = NodeEvents.EventEmitter;
var CommonMessages = Inovx.Shared.Common.CommonMessages;

var CHANGE_EVENT = 'Role.change'
var FORM_ADD_ROLE_NAME = RoleConstants.ROLE_ADD_FORM;
var _roles: IOrganizationRole[] = [],
    _settings: IRoleSettings = { IsExternalAuthentication: false },
    _externalGroups: IExternalGroup[] = [],
    _role: IOrganizationRoleDetail | any = getBlankRole(false),
    _modalVisible = false,
    _beginAdd = false,
    _beginEdit = false,
    _hasChanges = false,
    _validation: IValidationStoreObject = {};


function setAddingRole(isLinkedRole: boolean) {
    _beginAdd = _modalVisible = true;
    _beginEdit = false;
    _hasChanges = false;
    _role = getBlankRole(isLinkedRole);
    _initalizeValidation(FORM_ADD_ROLE_NAME);
}

function setEditingRole(role: IOrganizationRoleDetail) {
    _modalVisible = _beginEdit = true;
    _beginAdd = false;
    _hasChanges = false;
    _role = { ...role };
    _initalizeValidation(FORM_ADD_ROLE_NAME);
}

function addExternalGroup(externalGroup: IExternalGroup) {

    var exists = false;
    for (var grpIndx in _role.LinkedExternalGroups) {
        if (externalGroup.ID === _role.LinkedExternalGroups[grpIndx].ID) {
            exists = true;
            break;
        }
    }
    if (!exists) {
        _role.LinkedExternalGroups.push(externalGroup);
        _hasChanges = true;
    }
}

function deleteExternalGroup(externalGroup: IExternalGroup) {
    for (var index in _role.LinkedExternalGroups) {
        if (_role.LinkedExternalGroups[index].ID == externalGroup.ID) {
            _role.LinkedExternalGroups.splice(index as any, 1);
            _hasChanges = true;
            break;
        }
    };
}

function _initalizeValidation(comp: string) {
    switch (comp) {
        case FORM_ADD_ROLE_NAME:

            var valiObj: IValidationDictionaryObject = _validation[FORM_ADD_ROLE_NAME] = {};

            for (var k in _role) {
                _setValidValidation(FORM_ADD_ROLE_NAME, k);
            }

            break;
    }
}

function _setValidValidation(comp: string, name: string) {
    if (_validation[comp][name]) {
        _validation[comp][name].invalidInput = false;
        _validation[comp][name].invalidValue = false;
    } else {
        _validation[comp][name] = _getNewValidationObject();
    }
}

function _getNewValidationObject() {
    return {
        invalidInput: false,
        invalidValue: false
    } as IValidationObject;
}

function _validate(comp: string) {
    switch (comp) {
        case FORM_ADD_ROLE_NAME:
            return _validateObject(comp, _role);
    }

    return false;
}

function _ensureValidObject(comp: string, obj: any) {
    for (var k in obj) {
        switch (comp) {
            case FORM_ADD_ROLE_NAME:
                var objType = typeof (obj[k]);
                if (objType !== 'function') {
                    if (obj[k] === null || objType !== 'object') {
                        _updateChanges(k, obj[k]);
                    } else {
                        _ensureValidObject(comp, obj[k]);
                    }
                }
        }
    }
}

function _validateObject(comp: string, obj: any) {
    _ensureValidObject(comp, obj);

    var ret = true;

    for (var k in _validation[FORM_ADD_ROLE_NAME]) {
        if (_validation[FORM_ADD_ROLE_NAME][k].invalidValue) {
            return false;
        }
    }

    return ret;
}

function _updateChanges(name: string, value: string) {
    switch (name) {
        case "IsLinkedRole":
            _role[name] = value;
            if (_role.IsLinkedRole == true) {
                if (_role.LinkedExternalGroups.length == 0) {
                    _validation[RoleConstants.ROLE_ADD_FORM][name].invalidValueMessage = InovxLoader.t("common:form.externalGroupEmpty");
                    _validation[RoleConstants.ROLE_ADD_FORM][name].invalidValue = true;
                }
                else {
                    _setValidValidation(RoleConstants.ROLE_ADD_FORM, name);
                }
            }
            else {
                _setValidValidation(RoleConstants.ROLE_ADD_FORM, name);
            }
            break;
        case "Name":
            _role[name] = value;
            if (value) {
                var dupName = false;
                for (var i = 0; i < _roles.length; i++) {
                    if (_role.Name.toUpperCase() === _roles[i].Name.toUpperCase()
                        && _role.ID.toUpperCase() !== _roles[i].ID.toUpperCase()) {
                        dupName = true;
                        break;
                    }
                }

                if (dupName) {
                    _validation[FORM_ADD_ROLE_NAME][name].invalidValue = true;
                    _validation[FORM_ADD_ROLE_NAME][name].invalidValueMessage = InovxLoader.t("role:message.invalidRole");
                } else {
                    _setValidValidation(FORM_ADD_ROLE_NAME, name);
                }
            } else {
                _validation[FORM_ADD_ROLE_NAME][name].invalidValue = true;
                _validation[FORM_ADD_ROLE_NAME][name].invalidValueMessage = CommonMessages.Validation.Required;
            }
            break;
        default:
            if (name != 'ID' && name != 'VersionToken') {
                _role[name] = value;
            }

            _setValidValidation(FORM_ADD_ROLE_NAME, name);
            break;
    }
}

function finishedEditingRole() {
    _modalVisible = false;
    _hasChanges = false;
}

function updateCurrentRole(comp: string, key: string, value: any) {
    switch (comp) {
        case FORM_ADD_ROLE_NAME:
            _updateChanges(key, value);
            _hasChanges = true;
            break;
    }
}

function addUsers(users: IUser[]) {
    for (var indx in users) {
        var exists = false;
        for (var grpIndx in _role.Users) {
            if (users[indx].UserID === _role.Users[grpIndx].UserID) {
                exists = true;
                break;
            }
        }
        if (!exists) {
            _role.Users.push(users[indx]);
        }
    }
    _hasChanges = true;
}

function deleteAuthorizedUser(user: IUser) {
    var authorizedUsers = _role.Users;
    for (var index in authorizedUsers) {
        if (authorizedUsers[index].UserName == user.UserName) {
            authorizedUsers.splice(index, 1);
            _hasChanges = true;
        }
    }
}
function loadAllRoles(data: IOrganizationRole[]) {
    fixRoleData(data);
    _roles = data;
}

function loadRoleSettingsData(data: IRoleSettings) {
    _settings = data;
}

function loadExternalGroups(data: IExternalGroup[]) {
    _externalGroups = data;
}

function getBlankRole(isLinkedRole: boolean): IOrganizationRoleDetail {
    return {
        ID: "",
        VersionToken: "",
        Name: "",
        Description: "",
        Type: 'V-Plant',
        Users: [],
        LinkedExternalGroups: [],
        IsLinkedRole: isLinkedRole
    }
}

function fixRoleData(data: IOrganizationRole[]) {
    if (data) {
        data.forEach((group) => {
            if (group.IsLinkedRole) {
                group.Type = InovxLoader.t('role:grid.linked');
            }
            else {
                group.Type = "V-Plant";
            }
        });
    }
}

var RoleStore: IRoleStore = Object.assign({}, EventEmitter.prototype, {
    getAll: function () {
        return _roles;
    },
    getExternalGroups: function () {
        return _externalGroups;
    },
    getSettings: function () {
        return _settings;
    },
    getRole: function () {
        return _role;
    },
    getIsAdding: function () {
        return _beginAdd;
    },
    getIsEditing: function () {
        return _beginEdit;
    },
    getModalVisible: function () {
        return _modalVisible;
    },
    getHasChanges: function () {
        return _hasChanges;
    },
    getValidation(key: string) {
        return _validation[key];
    },
    getIsValidObject(key: string) {
        return _validate(key);
    },
    emitChange: function () {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener: function (callback: any) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function (callback: any) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    isLinkedRole: function () {
        return _role.IsLinkedRole;
    },
});

Inovx.Shared.Flux.AppDispatcher.register(function (payload: any) {
    switch (payload.actionType) {
        case RoleConstants.ROLE_GET_ALL:
            loadAllRoles(payload.data);
            break;
        case RoleConstants.ROLE_BEGIN_ADD:
            setAddingRole(payload.isLinkedRole);
            break;
        case RoleConstants.ROLE_BEGIN_EDIT:
            setEditingRole(payload.role);
            break;
        case RoleConstants.ROLE_FINISH_EDIT:
            finishedEditingRole();
            break;
        case RoleConstants.ROLE_UPDATE_EDIT:
            updateCurrentRole(payload.component, payload.key, payload.value);
            break;
        case RoleConstants.ROLE_ADD_USER:
            addUsers(payload.users);
            break;
        case RoleConstants.ROLE_DELETE_USER:
            deleteAuthorizedUser(payload.user);
            break;
        case RoleConstants.ROLE_INVALID_ADD:
            break;
        case RoleConstants.ROLE_RECIEVE_SETTINGS_DATA:
            loadRoleSettingsData(payload.data);
            break;
        case RoleConstants.ROLE_ADD_EXTERNAL_GROUP:
            addExternalGroup(payload.externalGroup);
            break;
        case RoleConstants.ROLE_DELETE_EXTERNAL_GROUP:
            deleteExternalGroup(payload.externalGroup);
            break;
        case RoleConstants.ROLE_RECEIVE_SEARCH_HINT:
            loadExternalGroups(payload.data);
            payload.callback();
            return true;

        default: return true;
    }

    RoleStore.emitChange();

    return true;
});

export default RoleStore;
